import React from 'react';
import { Link } from 'react-router-dom';
import { Package, ArrowLeft, Mail, Phone, Clock, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const Contact = () => (
  <div className="min-h-screen bg-background font-manrope">
    <header className="border-b bg-white/80 backdrop-blur-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <Package className="w-8 h-8 text-accent" />
          <span className="text-xl font-bold text-primary">KAHA</span>
        </Link>
      </div>
    </header>

    <main className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <Button variant="ghost" asChild className="mb-6 gap-2" data-testid="btn-back-home">
        <Link to="/"><ArrowLeft className="w-4 h-4" /> Volver al inicio</Link>
      </Button>

      <div className="text-center mb-12">
        <h1 className="text-2xl sm:text-3xl font-bold text-primary mb-3">Contacto</h1>
        <p className="text-muted-foreground">
          Estamos para ayudarte con tus pedidos y cotizaciones.
        </p>
      </div>

      <div className="grid gap-5">
        {/* WhatsApp */}
        <a
          href="https://wa.me/524778055212?text=Hola%2C%20me%20gustar%C3%ADa%20m%C3%A1s%20informaci%C3%B3n%20sobre%20cajas%20personalizadas."
          target="_blank"
          rel="noopener noreferrer"
          className="block"
          data-testid="contact-whatsapp"
        >
          <Card className="border-green-200 bg-green-50/50 hover:bg-green-50 hover:border-green-300 transition-all cursor-pointer">
            <CardContent className="p-6 flex items-center gap-5">
              <div className="w-14 h-14 rounded-full bg-green-500 flex items-center justify-center shrink-0">
                <MessageCircle className="w-7 h-7 text-white" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-primary text-base">WhatsApp</p>
                <p className="text-sm text-muted-foreground">+52 477 805 5212</p>
                <p className="text-xs text-green-700 mt-1">Respuesta rápida — escríbenos directamente</p>
              </div>
              <svg className="w-5 h-5 text-muted-foreground shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg>
            </CardContent>
          </Card>
        </a>

        {/* Email */}
        <a href="mailto:hola@kahamx.com" className="block" data-testid="contact-email">
          <Card className="hover:bg-muted/30 hover:border-accent/30 transition-all cursor-pointer">
            <CardContent className="p-6 flex items-center gap-5">
              <div className="w-14 h-14 rounded-full bg-accent/10 flex items-center justify-center shrink-0">
                <Mail className="w-7 h-7 text-accent" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-primary text-base">Correo electrónico</p>
                <p className="text-sm text-muted-foreground">hola@kahamx.com</p>
                <p className="text-xs text-muted-foreground mt-1">Para cotizaciones, facturación y soporte general</p>
              </div>
              <svg className="w-5 h-5 text-muted-foreground shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg>
            </CardContent>
          </Card>
        </a>

        {/* Phone */}
        <a href="tel:+524778055212" className="block" data-testid="contact-phone">
          <Card className="hover:bg-muted/30 hover:border-accent/30 transition-all cursor-pointer">
            <CardContent className="p-6 flex items-center gap-5">
              <div className="w-14 h-14 rounded-full bg-accent/10 flex items-center justify-center shrink-0">
                <Phone className="w-7 h-7 text-accent" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-primary text-base">Teléfono</p>
                <p className="text-sm text-muted-foreground">+52 477 805 5212</p>
                <p className="text-xs text-muted-foreground mt-1">Llámanos en horario de atención</p>
              </div>
              <svg className="w-5 h-5 text-muted-foreground shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg>
            </CardContent>
          </Card>
        </a>

        {/* Hours */}
        <Card className="bg-muted/20">
          <CardContent className="p-6 flex items-center gap-5">
            <div className="w-14 h-14 rounded-full bg-accent/10 flex items-center justify-center shrink-0">
              <Clock className="w-7 h-7 text-accent" />
            </div>
            <div>
              <p className="font-semibold text-primary text-base">Horario de atención</p>
              <p className="text-sm text-muted-foreground">Lunes a viernes: 9:00 a 18:00 hrs</p>
              <p className="text-sm text-muted-foreground">Sábado: 9:00 a 14:00 hrs</p>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="mt-12 text-center">
        <p className="text-sm text-muted-foreground">
          Estamos ubicados en León, Guanajuato, México.
        </p>
        <p className="text-xs text-muted-foreground mt-2">
          Para pedidos urgentes, te recomendamos contactarnos por WhatsApp.
        </p>
      </div>
    </main>

    <footer className="py-8 bg-white border-t">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-sm text-muted-foreground">© {new Date().getFullYear()} KAHA Packaging. Todos los derechos reservados.</p>
      </div>
    </footer>
  </div>
);

export default Contact;
